export default __webpack_public_path__ + "static/mysql-560110c3e9380f9026f0866a60e05b2b.png";